/**
 * Cloud-styled Google map IDs, shared by the interactive map (index.tsx),
 * the print-only StaticMap, and the Static Maps preview URL builder. Single
 * source so the lazy preview visually matches the interactive map it replaces.
 */
export const MAP_IDS = {
  retail: '2fb27e1f36c5892d',
  white: '7d4b105263e52c2b'
} as const
